import { connect } from 'react-redux';
import { property } from 'lodash';
import TaxAuthoritySelect from '../components/TaxAuthoritySelect';

import { startRequest as managementsStartRequest } from '../redux/managements/actions';
import { startRequest as taxAuthoritiesStartRequest } from '../redux/taxAuthorities/actions';
import { startRequest as taxAuthorityAffiliatesStartRequest } from '../redux/taxAuthorityAffiliates/actions';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';

const mapStateToProps = createStructuredSelector({
  managements: property('contacts.managements'),
  taxAuthorities: property('contacts.taxAuthorities'),
  taxAuthorityAffiliates: property('contacts.taxAuthorityAffiliates'),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getManagements: managementsStartRequest,
      getTaxAuthorities: taxAuthoritiesStartRequest,
      getTaxAuthorityAffiliates: taxAuthorityAffiliatesStartRequest,
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(TaxAuthoritySelect);
